import React, { useMemo, useState } from 'react';

import { Box, Button, IconButton, useTheme, } from '@mui/material';

import { LocalizationToggle } from './localization';
import { useTranslation } from 'react-i18next';

import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { map } from 'lodash';
import { ArrowBack } from '@mui/icons-material';
import CompanyMenu from './CompanyMenu';
import SolutionsMenu from './solutions-menu';
import IndustriesMenu from './IndustriesMenu';
import ResourcesMenu from './ResourcesMenu';
import PricesMenu from './price-menu';

const links = [
    {
        title: "Company",
        renderMenu: () => <CompanyMenu />
    },
    {
        title: "solutions.caption",
        renderMenu: () => <SolutionsMenu />
    },
    {
        title: "features.caption",
        href: "/features"
    },
    {
        title: "Industries",
        renderMenu: () => <IndustriesMenu />
    },
    {
        title: "Pricing",
        renderMenu: () => <PricesMenu />
    },
    {
        title: "Resources",
        renderMenu: () => <ResourcesMenu />
    },
]

const PopperNavigation = ({ ...props }) => {

    const { t, i18n } = useTranslation('public');
    const theme = useTheme()

    const EndIcon = useMemo(() => {
        return theme.direction === "rtl" ?
            <KeyboardArrowLeftIcon sx={{ fontSize: '30px !important' }} /> :
            <KeyboardArrowRightIcon sx={{ fontSize: '30px !important' }} />
    }, [theme.direction])

    const [activeMenuItem, setActiveMenuItem] = useState();

    const transitionStyle = useMemo(() => {
        return activeMenuItem ? { left: 0 } : { left: '100vw' }
    }, [activeMenuItem])

    const handleExpandableMenuItemClick = (menuItem) => {
        setActiveMenuItem(menuItem);
    }

    return (
        <Box {...props}>
            {map(
                links,
                link =>
                    <Button
                        key={link?.title}
                        fullWidth
                        variant="standard"
                        endIcon={link?.href ? null : EndIcon}
                        href={link?.href}
                        disableTouchRipple
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: link?.href ? 'flex-start' : 'space-between',
                            paddingInline: 0,
                            color: '#1E1E1E',
                            fontSize: '16px',
                            fontStyle: 'normal',
                            fontWeight: '500',
                            lineHeight: '130%',
                            textTransform: 'none',
                            paddingBlock: 2,
                            cursor: 'pointer',
                            ':hover': {
                                backgroundColor: 'transparent'
                            }
                        }}
                        onClick={link ? () => handleExpandableMenuItemClick(link) : null}
                    >
                        {t(link.title)}
                    </Button>
            )}
            <LocalizationToggle reload={true} />
            <Box sx={{
                borderLeft: '1px solid #E8E9EB',
                borderRight: '1px solid #E8E9EB',
                position: 'absolute',
                top: 0,
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'stretch',
                backgroundColor: 'white.main',
                transitionProperty: 'left',
                transitionDuration: '0.5s',
                ...transitionStyle,
                minWidth: '100vw',
                minHeight: '100vh',
            }}>
                <IconButton
                    disableRipple
                    onClick={() => handleExpandableMenuItemClick(null)}
                    sx={{
                        marginInlineStart: {xs: 0, md: 4},
                        marginBlockStart: 2,
                        p: 0,
                        ':hover': { backgroundColor: 'transparent !important' },
                        alignSelf: 'flex-start',
                        color: '#1E1E1E',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: 500,
                        lineHeight: '130%',
                        borderRadius: 0,
                    }}
                >
                    <ArrowBack sx={{ color: '#000', marginInlineStart: 0, fontSize: '20px', transform: `scaleX(${i18n.dir() === "rtl" ? -1 : 1})`, marginInlineEnd: 1 }} />
                    {t("Back to Menu")}
                </IconButton>
                {activeMenuItem?.renderMenu()}
            </Box>
        </Box >
    )
}

export default PopperNavigation;
